module.exports = __webpack_public_path__ + "img/robi.e2c6bd8d.jpeg";